import { SpinResponse } from '@cgs/data-access';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  GameStateMachine,
  IGameConfigProvider,
  IGameStateMachineProvider,
  IReelsEngineProvider,
  IStopSlotActionProvider,
  ReelsEngine,
  ReelsSoundModel,
  RegularSpinsSoundModelComponent,
  SpinMode,
  T_IGameConfigProvider,
  T_ISlotGameEngineProvider,
  T_RegularSpinsSoundModelComponent,
  CollapseGameConfig,
} from '@cgs/machines';
import { Container, IntervalAction } from '@cgs/wge';
import { SantaFreeFallStopAction } from './santa-free-fall-stop-action';

export class SantaFreeFallStopActionComponent implements IStopSlotActionProvider {
  private readonly _container: Container;
  private readonly _reelsEngine: ReelsEngine;
  private readonly _gameConfig: CollapseGameConfig;
  private readonly _gameStateMachine: GameStateMachine<SpinResponse>;
  private readonly _reelSoundModel: ReelsSoundModel;

  constructor(container: Container) {
    this._container = container;
    this._gameStateMachine = this._container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;

    this._reelSoundModel = this._container.resolve<RegularSpinsSoundModelComponent>(
      T_RegularSpinsSoundModelComponent
    ).regularSpinSoundModel;

    this._reelsEngine =
      this._container.resolve<IReelsEngineProvider>(T_ISlotGameEngineProvider).reelsEngine;

    this._gameConfig = this._container.resolve<IGameConfigProvider>(T_IGameConfigProvider)
      .gameConfig as CollapseGameConfig;
  }

  public getStopSlotAction(_spinMode: SpinMode): IntervalAction {
    return new SantaFreeFallStopAction(
      this._container,
      this._reelsEngine,
      this._gameStateMachine.curResponse.viewReels,
      this._reelSoundModel,
      this._gameConfig.regularSpinCollapsingConfig
    );
  }
}
